import { useCallback, useRef, useState } from "react";

// Защита от повторной отправки: пока запрос выполняется, следующие вызовы run() игнорируются.
// busy — для блокировки кнопки. Проверка идёт через ref, поэтому срабатывает и при
// быстрых кликах подряд, до перерисовки кнопки.
export function useSingleFlight() {
  const inFlightRef = useRef(false);
  const [busy, setBusy] = useState(false);

  const run = useCallback(async <T,>(request: () => Promise<T>): Promise<T | undefined> => {
    if (inFlightRef.current) return undefined;
    inFlightRef.current = true;
    setBusy(true);
    try {
      return await request();
    } finally {
      inFlightRef.current = false;
      setBusy(false);
    }
  }, []);

  return { busy, run };
}
